import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroBanner from "./components/HeroBanner";
import CategoryNav from "./components/CategoryNav";
import HotRanking from "./components/HotRanking";
import LatestUpdates from "./components/LatestUpdates";
import Recommended from "./components/Recommended";
import NewsletterSection from "./components/NewsletterSection";

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "韩漫世界 - 无删减韩漫大全",
  description: "访问韩漫网站探索无删减韩漫大全和好看的韩国漫画，免费下拉式观看模式操作便捷且自动加载",
  url: "https://hanmanshijie.com/",
  isPartOf: {
    "@type": "WebSite",
    name: "韩漫世界",
    url: "https://hanmanshijie.com/",
  },
  breadcrumb: {
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "首页",
        item: "https://hanmanshijie.com/",
      },
    ],
  },
};

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <Navbar />
      <main>
        <HeroBanner />
        <CategoryNav />
        <HotRanking />
        <LatestUpdates />
        <Recommended />
        <NewsletterSection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
    </>
  );
}